"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var file_1 = __importDefault(require("relements/build/esm/input/file"));
var upload_svg_1 = __importDefault(require("../../icons/upload.svg"));
require("./UploadGlossary.scss");
var defaults = {
    onUpload: function () { return null; },
    disableUpload: false,
};
/**
 * Upload a .csv file
 * @param Props
 * @component
 */
var UploadGlossary = function (_a) {
    var _b = _a === void 0 ? defaults : _a, onUpload = _b.onUpload, disableUpload = _b.disableUpload;
    // Validate Glossary file
    var validateFile = function (allowedFileTypes, file, fileType) {
        var isValid;
        var allowedTypes = __spreadArrays(allowedFileTypes, ['vnd.ms-excel']);
        if (fileType === '') {
            isValid = file.name.includes('.csv');
        }
        else {
            isValid = allowedTypes.includes(fileType);
        }
        return isValid;
    };
    return (react_1["default"].createElement("div", { className: "uploadGlossary " + (disableUpload && 'disabled') },
        react_1["default"].createElement(file_1["default"], { type: ".csv", className: "uploadGlossary-file", prefixClassName: "uploadGlossary-file", customIcon: upload_svg_1["default"], onUpload: onUpload, customValidate: validateFile, maxFileSize: 2 })));
};
exports["default"] = UploadGlossary;
